import { Skeleton } from '@crehana/compass.ui/skeleton';

export const CareerSiteSkeleton = () => {
  return (
    <div className="tw-w-full tw-h-screen tw-bg-neutral-light-100">
      {/* Header Skeleton */}
      <div className="tw-w-full tw-h-64 tw-bg-neutral-light-200 tw-relative">
        <div className="tw-absolute tw-top-8 tw-left-8">
          <Skeleton className="tw-h-12 tw-w-32" />
        </div>
        <div className="tw-absolute tw-top-16 tw-left-8 tw-right-8">
          <Skeleton className="tw-h-8 tw-w-3/4" />
        </div>
        <div className="tw-absolute tw-top-24 tw-left-8 tw-right-8">
          <Skeleton className="tw-h-4 tw-w-1/2" />
        </div>
        <div className="tw-absolute tw-bottom-8 tw-left-8">
          <Skeleton className="tw-h-10 tw-w-32" />
        </div>
      </div>

      {/* Content Skeleton */}
      <div className="tw-w-full tw-p-8">
        <div className="tw-w-full tw-mb-6">
          <Skeleton className="tw-h-6 tw-w-48 tw-mb-4" />
          <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-4">
            {Array.from({ length: 6 }).map((_, index) => (
              <div
                // biome-ignore lint/suspicious/noArrayIndexKey: <in this case is needed because the array is not rendered info the table>
                key={index}
                className="tw-bg-white tw-rounded-lg tw-p-4 tw-border tw-border-neutral-light-300"
              >
                <Skeleton className="tw-h-4 tw-w-3/4 tw-mb-2" />
                <Skeleton className="tw-h-3 tw-w-1/2 tw-mb-2" />
                <Skeleton className="tw-h-3 tw-w-1/3" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
